module.exports = __webpack_public_path__ + "img/image (16).340127ef.webp";